export function isMobileDevice() {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = window.navigator ? window.navigator.userAgent || '' : '';
  const mobileRegex = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i;
  const maxMobileWidth = 768;

  return mobileRegex.test(userAgent) || window.innerWidth <= maxMobileWidth;
}
